import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/LoadDataIfNeeded";
import {
    buildGA4ItemsFromCartLines,
    getCurrencyCode,
    trackGA4BeginCheckout,
} from "@thkStore/Common/Utilities/ga4EcommerceTracking";

const GA4_BEGIN_CHECKOUT_KEY = "ga4_begin_checkout_cartId";

const SendGA4BeginCheckoutEvent: typeof ExecuteOnSuccessCallback = props => {
    const state = props.getState();
    const { cartId } = state.pages.onePageCheckout;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;

    if (!cart?.cartLines?.length) {
        return;
    }

    const effectiveCartId = cart.id || cartId || "current";
    try {
        if (sessionStorage.getItem(GA4_BEGIN_CHECKOUT_KEY) === effectiveCartId) {
            return;
        }
        sessionStorage.setItem(GA4_BEGIN_CHECKOUT_KEY, effectiveCartId);
    } catch {
        // sessionStorage unavailable
    }

    const currency = getCurrencyCode(state);
    const items = buildGA4ItemsFromCartLines(cart.cartLines);

    trackGA4BeginCheckout(items, currency, cart.orderSubTotal, cart.promotionCode || undefined);
};

addToChainAfter(chain, ExecuteOnSuccessCallback, SendGA4BeginCheckoutEvent);

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
